import React, { useState } from 'react';
import {
  Box,
  TextField,
  Button,
  Typography,
  Alert,
  Container,
  Paper
} from '@mui/material';

const LoginTest = () => {
  const [credentials, setCredentials] = useState({
    username: 'admin',
    password: 'admin123'
  });
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setResult(null);

    try {
      console.log('Attempting login...');
      
      const response = await fetch('/api/auth/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(credentials)
      });
      
      const data = await response.json();
      
      console.log('Response:', data);
      
      if (response.ok && data.success) {
        setResult({
          type: 'success',
          message: 'Login Successful!',
          data: data
        });
      } else {
        setResult({
          type: 'error',
          message: 'Login Failed',
          data: data
        });
      }
      
    } catch (error) {
      console.error('Login error:', error);
      setResult({
        type: 'error',
        message: 'Network Error',
        data: { error: error.message }
      });
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCredentials(prev => ({
      ...prev,
      [name]: value
    }));
  };

  return (
    <Container maxWidth="sm">
      <Box sx={{ mt: 4 }}>
        <Paper sx={{ p: 4 }}>
          <Typography variant="h4" gutterBottom>
            🔐 Login Test
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
            Testing login functionality with the backend
          </Typography>

          <form onSubmit={handleSubmit}>
            <TextField
              fullWidth
              label="Username"
              name="username"
              value={credentials.username}
              onChange={handleChange}
              margin="normal"
              required
            />
            
            <TextField
              fullWidth
              label="Password"
              name="password"
              type="password"
              value={credentials.password}
              onChange={handleChange}
              margin="normal"
              required
            />
            
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
              disabled={loading}
            >
              {loading ? 'Logging in...' : 'Login'}
            </Button>
          </form>

          {result && (
            <Alert 
              severity={result.type === 'success' ? 'success' : 'error'}
              sx={{ mt: 2 }}
            >
              <Typography variant="h6">
                {result.type === 'success' ? '✅ ' : '❌ '}
                {result.message}
              </Typography>
              
              {result.type === 'success' && (
                <Box sx={{ mt: 1 }}>
                  <Typography variant="body2">
                    <strong>User:</strong> {result.data.user.username}
                  </Typography>
                  <Typography variant="body2">
                    <strong>Role:</strong> {result.data.user.role}
                  </Typography>
                  <Typography variant="body2">
                    <strong>Token:</strong> {result.data.token}
                  </Typography>
                </Box>
              )}
              
              {result.type === 'error' && (
                <Typography variant="body2" sx={{ mt: 1 }}>
                  <strong>Error:</strong> {result.data.message || result.data.error}
                </Typography>
              )}
            </Alert>
          )}
        </Paper>
      </Box>
    </Container>
  );
};

export default LoginTest;
